import Api from "../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        searchFields: [
            {
                name: "userId",
                label: "Felhasználó",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getUserWithEesztUser,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "loginTimeFrom",
                label: "Időponttól",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "loginTimeTo",
                label: "Időpontig",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "ip",
                label: "IP cím",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                sort: true,
                visibility: false,
            },
            {
                name: "user.username",
                label: "Felhasználónév",
                sort: false,
                visibility: true,
            },
            {
                name: "eesztUsername",
                label: "EESZT felhasználónév",
                sort: false,
                visibility: true,
            },
            {
                name: "time",
                label: "Bejelentkezési idő",
                sort: true,
                slot_name: "datetime_format",
            },
            {
                name: "ip",
                label: "IP cím",
                sort: false,
            },
            {
                name: "os",
                label: "Operációs rendszer",
                sort: false,
            },
            {
                name: "browser",
                label: "Böngésző",
                sort: false,
            },
            {
                name: "browserVersion",
                label: "Böngésző verzió",
                sort: false,
            },
            {
                name: "browserPlugins",
                label: "Bőngésző plugins",
                visibility: false,
            },
            {
                name: "resolution",
                label: "Resolution",
                visibility: false,
            }
        ]
    }
}
